<template>
  <div class="theme-green content">
    <ly-header></ly-header>
    <ul class="title">
      <li
        v-for="(item,index) of menu"
        :key="item.kid"
        @click="HandleClick(index)"
        :class="{on:istrue==index}"
      >{{item.name}}</li>
    </ul>
    <div class="nav-content">
      <today-order v-if="isShow"></today-order>
      <history-analyse v-if="!isShow"></history-analyse>
    </div>
  </div>
</template>

<script>
// 订单管理
import LyHeader from "./common/Header";
// 今日订单
import TodayOrder from "../order/TodayOrder";
// 历史任务分析
import HistoryAnalyse from "../order/HistoryAnalyse";
export default {
  name: "Order",
  data() {
    return {
      istrue: 0,
      isShow: true,
      menu: [
        {
          name: "今日订单",
          kid: 1
        },
        {
          name: "历史任务分析",
          kid: 2
        }
      ]
    };
  },
  components: {
    LyHeader,
    TodayOrder,
    HistoryAnalyse
  },
  methods: {
    HandleClick(index) {
      this.istrue = index;
      if (index == 0) {
        this.isShow = true;
      } else if (index == 1) {
        this.isShow = false;
      }
    }
  }
};
</script>


<style scoped>
.content {
  width: 1918px;
  height: 853px;
  margin: 0 auto;
  position: relative;
  background-color: #348975;
      overflow: hidden;
}
.title {
  margin-top: 113px;
  width: 1920px;
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
}
.title li {
  width: 130px;
  height: 34px;
  line-height: 34px;
  margin-left: 30px;
  border-radius: 8px;
  text-align: center;
  background: #1515151a;
  cursor: pointer;
}
.title .on {
  color: #257153;
  background-color: #9ed0bd;
}
.nav-content {
  padding: 10px 10px;
  height: calc(100% - 174px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}
</style>




// WEBPACK FOOTER //
// src/components/xiayan/home/Order.vue